import {
  DeleteMeDocument,
  GetUserDocument,
  UpdateUserDocument,
  UpdateUserInput,
  UpdateUserMutation,
} from '@/core/graphql/types';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

export class UserApi {
  private client: ApolloClient<NormalizedCacheObject>;

  constructor(client: ApolloClient<NormalizedCacheObject>) {
    this.client = client;
  }

  async getUser() {
    const { data: { me } } = await this.client.query({
      query: GetUserDocument,
      variables: {
      },
    });

    return me;
  }

  async deleteUser(): Promise<boolean> {
    const { data: { deleteMe } } = await this.client.query({
      query: DeleteMeDocument,
    });

    return deleteMe;
  }

  async updateUser(input: UpdateUserInput): Promise<UpdateUserMutation['updateUser']> {
    const { data: { updateUser } } = await this.client.query({
      query: UpdateUserDocument,
      variables: {
        input,
      },
    });

    return updateUser;
  }

  async setFcmToken(id: string, token: string) {
    return this.client.query({
      query: UpdateUserDocument,
      variables: {
        input: {
          id,
          timezoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
          fcmToken: token,
        },
      },
    });
  }
}
